import React from 'react';
import Helmet from 'react-helmet';
import './App.css';
import * as content from './Content.js';
import Modal from './Modal.js';
import './Meta.js';

//const themeBlue = '#08222c';
//const themePink = '#ffb4b2';

const title = "US elections | a socialist conference";
const description = "US politics is in turmoil. The pandemic is sweeping through the nation and ravaging an already underfunded healthcare system. The scourge of police racism and violence continues but has been challenged by the largest social rebellion since the 1960s.";
const image = 'https://electionsconference.redflag.org.au/square_banner.png';
const url = "https://electionsconference.redflag.org.au";


class Sessions extends React.Component {
    renderSession(i) {
        return (
            <ConfSession
                name={content.sessionInfo[i]["name"]}
                description={content.sessionInfo[i]["description"]}
                readings={content.sessionInfo[i]["readings"]}
            />
        );
    }
    render() {
        return (
            <div id="program" class="program">
                <div class="program-header">
                    <h1>Program</h1>
                </div>
                <h2>12pm</h2>
                {this.renderSession(0)}
                <h2>2pm</h2>
                {this.renderSession(1)}
                {this.renderSession(2)}
                <h2>4pm</h2>
                {this.renderSession(3)}
                {this.renderSession(4)}
            </div>
        );
    }
}

class ConfSession extends React.Component {
    state = {
        show: false
    };
    showModal = e => {
        this.setState({
            show: !this.state.show
        });
    };
    render() {
        return (
            <div class="session">
                <div class="session_box" onClick={e => { this.showModal();}}>
                    {this.props.name}
                    <p><i>Click for more info</i></p>
                </div>
                <Modal
                    onClose={this.showModal}
                    show={this.state.show}
                    name={this.props.name}
                    description={this.props.description}
                    readings={this.props.readings}
                />
            </div>
        );
    }

}

class Intro extends React.Component {
    render() {
        return (
            <div id ="header" class="header">
                <div class="banner_wrapper">
                    <a href="#intro">
                        <img alt="" class="desktop_banner" src='/banner.png' />
                        <img alt="" class="square_banner" src='/square_banner.png' />
                        <img alt="" class="mobile_banner" src='/poster.png' />
                    </a>
                </div>
                <div id="intro" class="intro">
                    {content.introText}
                </div>
            </div>
        );
    }
}

class Tickets extends React.Component {
    render() {
        return (
            <div id="tickets" class="tickets">
                <h1>Tickets</h1>
                {content.ticket_text}
            </div>
        );
    }
}

class SpeakerList extends React.Component {
    renderSpeaker(i) {
        return (
            <Speaker
                name={content.speakers[i]["name"]}
                description={content.speakers[i]["description"]}
            />
        );
    }
    render() {
        return (
            <div id="speakers" class="speakers">
                <h1>Guest Speakers</h1>
                {this.renderSpeaker(0)}
                {this.renderSpeaker(1)}
            </div>
        );
    }

}

class Speaker extends React.Component {
    render() {
        return (
            <div class="speaker">
                <h2>{this.props.name}</h2>
                    {this.props.description}
            </div>
        );
    }
}

class Info extends React.Component {
    render() {
        return (
            <div id="info" class="info">
                <h1>Venue Info</h1>
                {content.venueInfo}
            </div>
        );
    }
}

class Contact extends React.Component {
    render() {
        return (
            <div id="contact" class="contact">
                <h1>Contact</h1>
                {content.contactText}
            </div>
        );
    }
}


class NavBar extends React.Component {
    render() {
        return (
            <a href="#header">
                <div class="navbar">
                    <img alt="" className="navbar_l" src='/trump_head.png' />
                    <h1>US elections | a socialist conference</h1>
                    <img alt="" className="navbar_r" src='/biden_head.png' />
                </div>
            </a>
        );
    }
}

class Footer extends React.Component {
    render() {
        return (
            <div class="footer">
                <a href="#program">Program | </a>
                <a href="#tickets">Tickets | </a>
                <a href="#info">Info | </a>
                <a target="_blank" href="https://www.facebook.com/events/1273680756329269"><img className="fb_logo" src="/fb.png" /> </a>
            </div>
        );
    }
}

function App() {
    return (
        <>
            <div className="App">
                <Intro />
                <NavBar />
                <Sessions />
                <SpeakerList />
                <Tickets />
                <Info />
                <Contact />
                <Footer />
            </div>
        </>
    );
}

export default App;
